function Main({ children }) {
    return (
        <div>
            <main className='main'>
                {children}
                {/* <p>1/15</p>
                <p>Question?</p> */}
            </main>
        </div>
    )
}

export default Main
